// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YcZz","newExpiryDate":"styles_newExpiryDate__Al48Z","footer":"styles_footer__3q1hA"};